export default __webpack_public_path__ + "media/images/mailer/wordmark-d495cf96a1bde9cb864ba9fb1cbfcc57.png";